import React, { useState } from "react";
import t from "../../../helpers/t";
import { Dropdown, DropdownButton, moment } from "../../../../../vendor";
import ChangeMatrixField from "./ChangeMatrixField";

const MatrixField = (props) => {
  const {
    onChange,
    onChangeSortOrder,
    onRemove,
    item,
    count,
    index,
    matrixFields,
    tempMatrixFields,
    setMatrixFields,
    showChange,
    showChangeView,
    type,
    subpanel,
  } = props;
  const [matrixField, setMatrixField] = useState(item);
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  /* const onRemoveProduct = (product) => {

        if (confirm(t('really_remove'))) {
            props.dispatch(productsActions.deleteProduct(
                {
                    id: Number(product.id),
                    token: Biscuit.get('token')
                }
            ));
            props.dispatch(alertsActions.addAlert({
                message : t('removed_${a}',{a:t('product')}),
                icon : 'fi fi-trash',
            }));
            props.forceReInit();
        }
    };*/
  const changeMatrixField = () => {
    searchParams.set("subpanel", subpanel);
    searchParams.set("panel", 2);
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
    showChangeView(
      matrixField,
      setMatrixField,
      tempMatrixFields !== null ? tempMatrixFields : matrixFields,
      type,
    );
  };
  const localOnChange = (value) => {
    onChangeSortOrder(index, value);
  };
  const spaceHandle = (e) => {
    let clone2 = matrixFields;
    let ind = 0;
    let clone1 = matrixField;
    if (e.target.checked) {
      clone1.line_break = true;
      clone2.map(function (item, index) {
        if (item.id === clone1.id) {
          ind = index;
          return;
        }
      });
      clone2[ind].line_break = true;
      setMatrixFields(clone2);
      console.log(matrixField);
      props.addSpace("mF" + matrixField.id);
    } else {
      clone1.line_break = false;
      clone2.map(function (item, index) {
        if (item.id === clone1.id) {
          ind = index;
          return;
        }
      });
      clone2[ind].line_break = false;
      props.removeSpace("mF" + matrixField.id);
    }
    setMatrixFields(clone2);
    setMatrixField(clone1);
  };
  return (
    <>
      <aside className="inb-c-item__actions">
        <DropdownButton
          id="dropdown-basic-button"
          title="..."
          drop="right"
          menuAlign="right"
          bsPrefix="button round inb-toggle-contingent-dd hover"
        >
          <ul className="inb-dropdown__list">
            <li data-inb-action-link="edit">
              <Dropdown.Item href="#" onClick={changeMatrixField}>
                <i className="fi fi-wrench"></i>
                {t("edit_${a}", { a: t("element", null, "capital") })}
              </Dropdown.Item>
            </li>

            {/*<li>
                                <Dropdown.Item href="#" onClick={() => onRemove(index)}>
                                    <i className="fi fi-trash"></i>{t('remove', null, ' capital')}
                                </Dropdown.Item>
                            </li>*/}
          </ul>
        </DropdownButton>
      </aside>

      <div className="large-6 medium-6 small-12 column inb-matrix-field--name">
        <span className="inb-product--fullname inb-order-big" title="">
          {matrixField.display_name}
        </span>
        <br />
      </div>
      {typeof props.type !== "undefined" && props.type === "user" && (
        <>
          <div className="large-6 medium-6 small-12 column inb-matrix-field--space">
            <label style={{ fontSize: "8px" }}>{t("line break")} </label>
            <input type="checkbox" defaultChecked={matrixField.line_break} onChange={spaceHandle} />
          </div>
        </>
      )}
      {/*<div className="small-12 column inb-product--name" style={{paddingTop:"25px"}}>
                <input className="inb-matrix-field--name inb-order" title={t('name')} value ={matrixField.name === null?"":matrixField.name}></input><br />
            </div>
            <div className="small-10 small-offset-2 column">
                <div className="inb-product--type" title="">
              <span style={{float:"left",minWidth:"49%"}}>

                  </span>


                        <div className="sort_order" title="" style={{paddingBottom:"10px"}}>
                            <SortButtons
                                item={matrixField}
                                onChange={localOnChange}
                                last={count}
                                sortOrder={matrixField.sort}
                                field="sort"
                            />
                        </div>


                </div>
            </div>*/}
    </>
  );
};

export default MatrixField;
